export enum LeadStatus {
  DISPONIVEL = 'DISPONIVEL',
  INDISPONIVEL = 'INDISPONIVEL',
  EM_TRATAMENTO = 'EM_TRATAMENTO',
  VENDIDO = 'VENDIDO',
  PERDIDO = 'PERDIDO',
  APAGADO = 'APAGADO',
}
